/**
 * Backend bilan mos: ≥12 belgi, katta harf, kichik harf, raqam, maxsus belgi.
 */
export function isNewPasswordValid(password) {
    if (password == null || typeof password !== 'string') {
        return false;
    }
    if (password.length < 12) {
        return false;
    }
    if (!/[A-Z]/.test(password)) {
        return false;
    }
    if (!/[a-z]/.test(password)) {
        return false;
    }
    if (!/[0-9]/.test(password)) {
        return false;
    }
    if (!/[^A-Za-z0-9]/.test(password)) {
        return false;
    }
    return true;
}
